module.exports = __webpack_public_path__ + "static/VideoYeimitMirandasub-f422c9d106ef8de3bb397a41386ccc99.mp4";